// extracted by mini-css-extract-plugin
module.exports = {"messageItem":"CancelPopup_messageItem__2H8rd","messageListItem":"CancelPopup_messageListItem__3eKjm"};